var _effectorFileName = "/builds/gmini/front-ui-kit/src/SelectMultiple/components/Input/Input.styled.ts";
import styled, { css } from 'styled-components';
import { ScrollBar } from '../../../ScrollBar';
import { RenderSelectInputValueWrapper } from '../../../Select/components/Input/Input.styled';
import { BubbleSelectMultiple } from '../BubbleSelectMultiple';
export const RenderSelectInputValue = styled.div`
  position: absolute;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.disabled ? 'rgba(53, 59, 96, 0.2)' : '#353b60'};
  letter-spacing: 0.1px;
  padding: 9.5px 0 9.5px 12px;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0 8px;
  white-space: nowrap;
  width: calc(100% - 55px);
  top: 1px;
  left: 2px;
  overflow: hidden;
  background: ${props => props.colorScheme === 'white' ? '#fff' : '#F5F5F7'};
  ${props => props.disabledSelect && (props.colorScheme === 'white' ? css`
          background: rgba(255, 255, 255, 0.5);
        ` : css`
          background: rgba(244, 244, 248, 0.5);
        `)}

  ${RenderSelectInputValueWrapper} {
    ${props => props.disabled && css`
        background: #fff;
      `}
  }

  ${BubbleSelectMultiple} {
    margin-top: 2px;
  }
`;
export const RenderSelectInputValueText = styled.div`
  overflow: hidden;
`;
export const TooltipScrollbar = styled(ScrollBar)`
  max-height: 300px;
  overflow: auto;
  width: 250px;
`;